import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const VyrobekNd = {
	name: NAME,
	apiProvider,
	router,
};
